import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './LegalPage.css';

const legalNav = [
  { label: 'Terms & Conditions', path: '/terms' },
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Shipping & Delivery', path: '/shipping' },
  { label: 'Cancellation Policy', path: '/cancellation' },
  { label: 'Return & Refund Policy', path: '/returns' },
];

const HELP = `https://wa.me/918871081395?text=${encodeURIComponent('Hi Maviinci, I have a question about your policies.')}`;

export default function LegalPageLayout({ title, subtitle, lastUpdated, children, activePath }) {
  const seoTitle = `${title} | MAVIINCI`;
  const seoDesc = subtitle || `Read MAVIINCI's official ${title}. Learn more about our guidelines, operational policies, terms and customer agreements.`;
  const seoUrl = `https://www.maviinci.in${activePath}`;

  return (
    <div className="legal-page-root">
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDesc} />
        <link rel="canonical" href={seoUrl} />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDesc} />
        <meta property="og:url" content={seoUrl} />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Hero Banner */}
      <div className="legal-hero">
        <div className="legal-hero-inner">
          <p className="legal-hero-eyebrow">Maviinci policies</p>
          <h1 className="legal-hero-title">{title}</h1>
          {subtitle && <p className="legal-hero-subtitle">{subtitle}</p>}
          {lastUpdated && (
            <p className="legal-hero-date">Last updated: {lastUpdated}</p>
          )}
        </div>
      </div>

      <div className="legal-body">
        {/* Sidebar Nav */}
        <aside className="legal-sidebar">
          <p className="legal-sidebar-heading">Policies</p>
          <nav className="legal-sidebar-nav">
            {legalNav.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`legal-sidebar-link ${activePath === item.path ? 'active' : ''}`}
              >
                <span className="legal-sidebar-dot" />
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="legal-help">
            <strong>Questions?</strong>
            <p>Ask us before you order. A tailor replies on WhatsApp.</p>
            <a href={HELP} target="_blank" rel="noopener noreferrer">WhatsApp us</a>
          </div>
        </aside>

        {/* Content */}
        <main className="legal-content">
          {children}
        </main>
      </div>
    </div>
  );
}
